import { render } from "./FormsListView.vue?vue&type=template&id=96e69b08&scoped=true"
import script from "./FormsListView.vue?vue&type=script&lang=js"
export * from "./FormsListView.vue?vue&type=script&lang=js"

import "./FormsListView.vue?vue&type=style&index=0&id=96e69b08&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96e69b08"]])

export default __exports__